module.exports = __webpack_public_path__ + "img/T6-B-17.85c652aa.png";